<template>
  <div class="setting-user-notifications" v-if="groups.length > 0 && currentGroup.contractConfirmAt">
    <div class="card">
      <div class="caption">通知メール設定</div>
      <div class="content">
        <div class="input-container">
          <el-switch
            v-model="notifications.is_campaign_start_end"
            @change="changeNotifications('is_campaign_start_end')"
            active-text="キャンペーン開始時と終了時"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_applicant_not_exists"
            @change="changeNotifications('is_applicant_not_exists')"
            active-text="キャンペーン開始1時間後に応募者が0件のとき"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_message_queue_send_finished"
            @change="changeNotifications('is_message_queue_send_finished')"
            active-text="メッセージの一括配信が完了"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_campaign_report_daily"
            @change="changeNotifications('is_campaign_report_daily')"
            active-text="キャンペーン経過報告(1日ごと)"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_campaign_report_hourly"
            @change="changeNotifications('is_campaign_report_hourly')"
            active-text="キャンペーン経過報告(1時間ごと)"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_campaign_collection_completed"
            @change="changeNotifications('is_campaign_collection_completed')"
            active-text="キャンペーンの最終集計が完了したとき"
          ></el-switch>
        </div>
        <div class="input-container">
          <el-switch
            v-model="notifications.is_sns_account_added"
            @change="changeNotifications('is_sns_account_added')"
            active-text="SNSアカウント追加時"
          ></el-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.card {
  margin-bottom: $spacing-unit * 2;

  .caption {
    margin-bottom: $spacing-unit * 2;
  }

  .content {
    .basic {
      margin-bottom: $spacing-unit * 0.5;
    }
  }
}

.input-container {
  display: flex;
  align-content: center;
  align-items: center;
  max-width: 100%;
  margin-bottom: $spacing-unit * 2;

  .input {
    flex: 1;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import api from '@/client/core/api'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  data() {
    return {
      notifications: {
        is_campaign_start_end: true,
        is_applicant_not_exists: true,
        is_message_queue_send_finished: true,
        is_campaign_report_daily: true,
        is_campaign_report_hourly: false,
        is_campaign_collection_completed: false,
        is_sns_account_added: true
      }
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      groups: state => state.groups,
      currentGroup: state => state.currentGroup
    })
  },
  async created() {
    const notifications = await api.get('/user_notifications')

    if (notifications.data) {
      this.notifications = { ...this.notifications, ...notifications.data }
    }
  },

  methods: {
    /**
     * 通知メール設定を変更する
     */
    async changeNotifications(value: string) {
      switch (value) {
        case 'is_campaign_start_end':
          TrackingService.sendEvent('switch:ユーザー情報|キャンペーン開始時と終了時')
          break
        case 'is_applicant_not_exists':
          TrackingService.sendEvent('switch:ユーザー情報|キャンペーン開始1時間後に応募者が0件のとき')
          break
        case 'is_message_queue_send_finished':
          TrackingService.sendEvent('switch:ユーザー情報|メッセージの一括配信が完了')
          break
        case 'is_campaign_report_daily':
          TrackingService.sendEvent('switch:ユーザー情報|キャンペーン経過報告（1日ごと）')
          break
        case 'is_campaign_report_hourly':
          TrackingService.sendEvent('switch:ユーザー情報|キャンペーン経過報告（1時間ごと）')
          break
        case 'is_campaign_collection_completed':
          TrackingService.sendEvent('switch:ユーザー情報|キャンペーンの最終集計が完了しとき')
          break
        case 'is_sns_account_added':
          TrackingService.sendEvent('switch:ユーザー情報|SNSアカウント追加されたとき')
          break
        default:
          break
      }

      const result = await api.put('/user_notifications', this.notifications)

      if (!result.data) {
        this.$notify({
          title: '通知メール設定の変更に失敗しました。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      this.$notify({
        title: '通知メール設定を変更しました。',
        customClass: 'success',
        duration: 5000
      })
    }
  }
})
</script>
